import { Box, Stack, Typography } from '@mui/material';
import section6_image from 'assets/img/ECommerce/section6_image.png';
import AnimatedButton from 'components/common/AnimatedButton';
import React, { JSX } from 'react';
import { E_COMMERCE_STYLES } from './config';
import { paths } from 'routes/routes/paths';
import { Link } from 'react-router-dom';

export default function Section6(): JSX.Element {
  return (
    <>
      <Box sx={{ px: 3, py: 0 }}>
        <Stack
          mb={4}
          px={1}
          spacing={0}
          textAlign={'start'}
          maxWidth={E_COMMERCE_STYLES.container.maxWidth}
          mx={E_COMMERCE_STYLES.container.mx}
        >
          <Typography
            variant="h4"
            maxWidth={400}
            lineHeight={'30px'}
            color="text.black"
            className="font-helvetica-thin"
          >
            The wrong choice can
            <b>
              <span style={{ color: '#FF2E2E' }}>
                {' '}
                cost you{' '}
                <span className="font-helvetica" style={{ letterSpacing: '1px' }}>
                  {' '}
                  millions — and years!{' '}
                </span>
              </span>
            </b>
          </Typography>
          <Typography
            mt={3}
            fontSize={'47px'}
            variant="h1"
            color="text.black"
            letterSpacing={'3px'}
            className="font-helvetica-extra-thin"
          >
            Choose Wisely.
          </Typography>
        </Stack>
      </Box>
      <Box
        maxWidth={E_COMMERCE_STYLES.container.maxWidthTablet}
        mx={E_COMMERCE_STYLES.container.mx}
        component="img"
        src={section6_image}
        alt="choose wisely"
        sx={{ width: '100%', borderRadius: 0, objectFit: 'contain' }}
      />
      <Stack sx={{ p: 3, py: 5, background: '#D9CAB5' }}>
        <Box maxWidth={E_COMMERCE_STYLES.container.maxWidth} mx={E_COMMERCE_STYLES.container.mx}>
          <Typography variant="h3" color="#755C38" className="font-helvetica-bold">
            We Take Time Because We Build What Sustain!
          </Typography>
          <Typography variant="body2" className="font-helvetica-light" color="#755C38">
            Unlike plug-and-play platforms that rush to go live and crumble under growth, we take
            the time to <b> understand your business</b>, your <b> workflows</b>, and your{' '}
            <b>customer psychology</b>.
          </Typography>
          <Typography my={1} variant="body2" className="font-helvetica-light" color="#755C38">
            Sustainable, scalable, and future-proof.
          </Typography>
          <Link to={paths.public.schedule}>
            <AnimatedButton
              label="No Rush — Let’s Connect"
              sx={{ textAlign: 'start', whiteSpace: 'nowrap', gap: 1 }}
            />
          </Link>

          <Typography
            mt={1}
            maxWidth={'280px'}
            variant="body2"
            color="#755C38"
            className="font-serif"
          >
            Just a{' '}
            <b>
              <u> 60-minute deep dive</u>{' '}
            </b>{' '}
            into what’s holding you back — and how to fix it.
          </Typography>
        </Box>
      </Stack>
    </>
  );
}
